/**
 * #862: a periodic read that runs only while the page is visible. A background tab stops
 * reading; when it becomes visible again it reads once at once, then resumes the beat.
 * Returns the stop function for a React effect cleanup.
 */
export function startVisibleInterval(
  tick: () => void,
  everyMs: number,
  doc: Pick<Document, 'hidden' | 'addEventListener' | 'removeEventListener'> = document,
): () => void {
  let timer: number | undefined;
  const pause = () => {
    if (timer !== undefined) window.clearInterval(timer);
    timer = undefined;
  };
  const onVisibility = () => {
    pause();
    if (doc.hidden) return;
    tick();
    timer = window.setInterval(tick, everyMs);
  };
  doc.addEventListener('visibilitychange', onVisibility);
  if (!doc.hidden) timer = window.setInterval(tick, everyMs);
  return () => {
    doc.removeEventListener('visibilitychange', onVisibility);
    pause();
  };
}
